var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFuelledFitnessLogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7ca97ff114"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34 41 L 354 41 L 354 320 L 34 320 Z M 34 41 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6d514c85af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 309.472656 32.550781 L 361.535156 94.59375 L 65.371094 343.105469 L 13.308594 281.0625 Z M 309.472656 32.550781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7958b7faba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 309.472656 32.550781 L 361.535156 94.59375 L 65.371094 343.105469 L 13.308594 281.0625 Z M 309.472656 32.550781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c7006a5a72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 309.472656 32.550781 L 361.535156 94.59375 L 65.371094 343.105469 L 13.308594 281.0625 Z M 309.472656 32.550781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fae79760f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42 26 L 121 26 L 121 95 L 42 95 Z M 42 26 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b308f7418"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "524ac025b9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4f1f029411"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50 38 L 142 38 L 142 118 L 50 118 Z M 50 38 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8b1aab5a84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d1a679eaf9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc4b1998a1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56 48 L 165 48 L 165 143 L 56 143 Z M 56 48 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef9d5701b6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1a708cc2fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b0d11f21fa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 154.769531 45.804688 L 166.683594 60.019531 L 65.652344 144.691406 L 53.738281 130.472656 Z M 154.769531 45.804688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "13ff8482c5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 154.769531 45.804688 L 166.683594 60.019531 L 65.8125 144.554688 L 53.898438 130.339844 Z M 154.769531 45.804688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d3b36f88f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 59 37 L 81 37 L 81 57 L 59 57 Z M 59 37 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ef56671f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8f392cb061"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2dd1e5ed46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 255 280 L 334 280 L 334 350 L 255 350 Z M 255 280 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03a0007d3a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9f41fd9ee3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9f6a354869"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 234 257 L 326 257 L 326 338 L 234 338 Z M 234 257 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "178681b6fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a8c9908e16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0222eebb99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211 233 L 320 233 L 320 328 L 211 328 Z M 211 233 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3bdcfcc2b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "59439519fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e3c9faf6c5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 309.660156 230.625 L 321.574219 244.84375 L 220.542969 329.511719 L 208.628906 315.296875 Z M 309.660156 230.625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1f1b40a545"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 309.660156 230.625 L 321.574219 244.84375 L 220.703125 329.378906 L 208.789062 315.160156 Z M 309.660156 230.625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "704e45ad9f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 295 318 L 316 318 L 316 338 L 295 338 Z M 295 318 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "64cb363b72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "23a54090f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "38cf0d291c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111 99 L 265 99 L 265 276 L 111 276 Z M 111 99 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "081ca3e99b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "74d80b09b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.5 0.00390625 L 359.976562 290.527344 L 258.996094 375.15625 L 15.519531 84.632812 Z M 116.5 0.00390625 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7ca97ff114)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6d514c85af)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7958b7faba)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c7006a5a72)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 221.238281 177.414062 C 226 173.421875 231.671875 170.648438 237.714844 169.320312 L 259 169.042969 C 268.238281 168.933594 277.105469 165.433594 283.957031 159.261719 L 352.417969 90.582031 C 354.238281 88.9375 354.4375 86.132812 352.910156 84.316406 C 351.386719 82.5 348.6875 82.320312 346.863281 83.964844 L 283.8125 142.339844 C 281.292969 144.601562 277.589844 144.5 275.578125 142.101562 C 273.5625 139.699219 274.03125 135.945312 276.585938 133.726562 L 340.75 76.675781 C 342.605469 75.078125 342.84375 72.320312 341.320312 70.503906 C 339.792969 68.683594 337.074219 68.484375 335.195312 70.058594 L 270.015625 125.898438 C 267.445312 128.097656 263.703125 127.949219 261.6875 125.546875 C 259.675781 123.148438 260.179688 119.4375 262.789062 117.285156 L 329.101562 62.792969 C 330.957031 61.195312 331.230469 58.480469 329.707031 56.664062 C 328.183594 54.847656 325.425781 54.601562 323.511719 56.132812 L 256.183594 109.414062 C 253.554688 111.542969 249.777344 111.351562 247.761719 108.953125 C 245.75 106.550781 246.289062 102.886719 248.957031 100.800781 L 317.394531 48.84375 C 319.328125 47.335938 319.621094 44.644531 318.097656 42.824219 C 316.570312 41.007812 313.777344 40.71875 311.84375 42.226562 L 232.320312 97.71875 C 225.050781 103.398438 220.101562 111.523438 218.347656 120.597656 L 214.378906 141.511719 C 212.019531 147.273438 208.308594 152.339844 203.550781 156.332031 C 203.550781 156.332031 136.9375 220.40625 61.136719 268.53125 C 61.136719 268.53125 21.007812 290.238281 39.320312 312.0625 C 57.632812 333.882812 85.976562 298.136719 85.976562 298.136719 C 146.574219 231.886719 221.238281 177.414062 221.238281 177.414062 Z M 221.238281 177.414062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fae79760f0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b308f7418)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#524ac025b9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 119.570312 34.394531 L 113.664062 27.351562 C 112.160156 25.554688 109.058594 25.675781 106.734375 27.621094 L 44.390625 79.871094 C 42.074219 81.816406 41.410156 84.84375 42.914062 86.640625 L 48.820312 93.6875 C 50.324219 95.484375 53.425781 95.363281 55.746094 93.417969 L 118.089844 41.171875 C 120.414062 39.226562 121.074219 36.191406 119.570312 34.394531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4f1f029411)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8b1aab5a84)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d1a679eaf9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 140.363281 46.402344 L 134.460938 39.355469 C 132.957031 37.5625 129.855469 37.683594 127.535156 39.628906 L 52.582031 102.441406 C 50.261719 104.386719 49.597656 107.421875 51.101562 109.214844 L 57.003906 116.261719 C 58.511719 118.058594 61.613281 117.9375 63.933594 115.992188 L 138.886719 53.175781 C 141.207031 51.230469 141.871094 48.199219 140.363281 46.402344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc4b1998a1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ef9d5701b6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a708cc2fc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b0d11f21fa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#13ff8482c5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 163.613281 56.355469 L 157.707031 49.308594 C 156.203125 47.515625 153.101562 47.636719 150.78125 49.582031 L 58.316406 127.070312 C 55.996094 129.015625 55.332031 132.050781 56.835938 133.84375 L 62.742188 140.890625 C 64.246094 142.6875 67.347656 142.566406 69.671875 140.621094 L 162.132812 63.128906 C 164.457031 61.183594 165.117188 58.152344 163.613281 56.355469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d3b36f88f4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ef56671f5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8f392cb061)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 70.203125 38.804688 L 61.796875 45.851562 C 59.472656 47.796875 59.175781 51.261719 61.128906 53.59375 L 63.484375 56.402344 L 80.292969 42.3125 L 77.9375 39.503906 C 75.984375 37.171875 72.523438 36.859375 70.203125 38.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2dd1e5ed46)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03a0007d3a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9f41fd9ee3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 332.554688 288.539062 L 326.652344 281.496094 C 325.148438 279.699219 322.042969 279.820312 319.722656 281.765625 L 257.378906 334.011719 C 255.058594 335.957031 254.398438 338.992188 255.902344 340.789062 L 261.808594 347.832031 C 263.3125 349.628906 266.414062 349.507812 268.730469 347.5625 L 331.074219 295.3125 C 333.398438 293.367188 334.0625 290.335938 332.554688 288.539062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9f6a354869)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#178681b6fc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a8c9908e16)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 324.371094 265.964844 L 318.464844 258.921875 C 316.960938 257.125 313.859375 257.246094 311.539062 259.1875 L 236.585938 322.003906 C 234.265625 323.949219 233.601562 326.984375 235.105469 328.78125 L 241.011719 335.824219 C 242.515625 337.621094 245.621094 337.496094 247.9375 335.554688 L 322.894531 272.738281 C 325.210938 270.792969 325.875 267.761719 324.371094 265.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0222eebb99)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3bdcfcc2b2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#59439519fc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e3c9faf6c5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1f1b40a545)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 318.636719 241.335938 L 312.730469 234.289062 C 311.226562 232.496094 308.125 232.617188 305.804688 234.5625 L 213.339844 312.054688 C 211.019531 314 210.355469 317.03125 211.859375 318.828125 L 217.765625 325.871094 C 219.269531 327.667969 222.371094 327.546875 224.695312 325.597656 L 317.15625 248.109375 C 319.480469 246.164062 320.140625 243.128906 318.636719 241.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#704e45ad9f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#64cb363b72)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#23a54090f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 314.34375 321.59375 L 311.988281 318.78125 L 295.175781 332.867188 L 297.535156 335.683594 C 299.484375 338.007812 302.949219 338.320312 305.269531 336.375 L 313.675781 329.328125 C 316 327.382812 316.296875 323.921875 314.34375 321.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#38cf0d291c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#081ca3e99b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#74d80b09b0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 111.171875 113.304688 L 247.488281 275.964844 L 264.296875 261.875 L 127.980469 99.214844 L 111.171875 113.304688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFuelledFitnessLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fuelled-fitness-logo.7d3f92a3f047ec7e58a57fc04f541537.svg";